import React, { Component, useEffect, useState, useCallback, useMemo, memo } from 'react';
import { Button, Col, Container, Row, Table } from 'reactstrap';

import I18N from '../I18N';
import YTab from '../c/YTab';
import Butt from '../c/Butt';
import { T, TraksConsumer } from '../traks';
import { R } from '../routes';
import { OpenLogin } from '../c/SignupLogin';

import { AUAContainer } from '../AUA';
import API from '../API';
import { Apify } from '../Apify';
import Me from '../Me';
import { site_base } from '../Site';
import TypeSelector from '../c/TypeInput';
import GenderSelector from '../c/GenderInput';
import PostcodeSelector from '../c/PostcodeInput';
import { formatDate, formatPrice } from '../c/PremiumKeys/Globals/GlobalUtils';
import { OrderDetailsModalInit } from '../c/OrderDetailsModal';
import { site_name } from '../Site';
import { OrderActionsModalInit } from '../c/OrderActionsModal';

const errcls = (has_error, cls) => cls + (has_error ? " ad_input_error" : "");

class NameEmailBirthdate extends Component {
	constructor(props) {
		super(props);
		const { aua } = this.props;

		this.state = {
            customer_type: aua.me.CustomerType ? aua.me.CustomerType.String : null,
            gender: aua.me.Gender ? aua.me.Gender.String : null,
			screen_name: aua.me.ScreenName,
			email: aua.me.LocalEmail,
            postal_code: aua.me.PostalCode.String,

			auth_password: "",
			email_err: "",
		};
	}

	render() {
		const { aua } = this.props;
		const { auth, me } = aua;

		const current_email = me.LocalEmail;
		const compulsory_passwd_auth = auth === "passwd";

		const require_current_password = compulsory_passwd_auth && this.state.email !== current_email;

		const can_disable_a_login = me.AuthCount > 1;

		const on_change = (e) => {
			this.setState({
				[e.target.name]: e.target.value
			});
		};

		var unverified_email_notice;
		if (me.UnverifiedEmailSinceTs > 0) {
			const mcls = "ad_prefs_email_notice";
			var infoicon = <img alt="info" src="/gfx/info-icon-0.svg"/>;
			var we_have_sent_you;
			if (Math.abs(me.UnverifiedEmailSinceTs - Date.now()/1000) > 1800) {
				const mailtime = I18N.datetime_shorter(new Date(me.UnverifiedEmailSinceTs * 1000));
				we_have_sent_you = <T>We've sent you a verification email to <tt>{current_email}</tt> at {mailtime}.</T>;
			} else {
				/* less than 30 minutes ago; don't bother showing a  timestamp */
				we_have_sent_you = <T>We've sent you a verification email to <tt>{current_email}</tt>.</T>;
			}
			unverified_email_notice = <div className={mcls}>{infoicon}{we_have_sent_you}</div>;
		}

		const email_changed = this.state.email.trim() !== current_email.trim();
		const email_removed = this.state.email.trim().length === 0;
		const screen_name_changed = this.state.screen_name !== aua.me.ScreenName;
        const customer_type_changed = this.state.customer_type !== aua.me.CustomerType.String;
        const gender_changed = this.state.gender !== aua.me.Gender.String;
        const postal_code_changed = this.state.postal_code !== aua.me.PostalCode.String;

		const can_submit = screen_name_changed || customer_type_changed || gender_changed || postal_code_changed || (email_changed && (!require_current_password || this.state.auth_password.length > 0));

		const validate_execute_email = (do_execute) => {
			if (!email_changed) {
				this.setState({email_err: ""});
				return;
			}

			const { email } = this.state;
			const validate_all_the_things = () => {
				if (!can_disable_a_login && me.HasPassword && email.trim().length === 0) {
					this.setState({email_err: "cannot_disable_login"});
					return false;
				} else {
					return true;
				}
			}

			if ((compulsory_passwd_auth && this.state.auth_password.length > 0) || do_execute) {
				const dryrun = !do_execute;
				if (dryrun || validate_all_the_things()) {
					const callback = (err) => {
						if (err) {
							this.setState({email_err: err.code});
						} else if (!do_execute) {
							if (validate_all_the_things()) {
								this.setState({email_err: ""});
							}
						} else if (do_execute) {
							this.setState({email_err: ""});
						}
					};
					if (email_removed) {
						aua.request.remove_email(this.state.auth_password, dryrun, callback);
					} else {
						aua.request.set_email_password(this.state.auth_password, this.state.email, null, dryrun, callback);
					}
				}
			} else {
				if (validate_all_the_things()) {
					this.setState({email_err: ""});
				}
			}
		};

		const validate_execute_screen_name = (do_execute) => {
			if (!screen_name_changed) {
				return;
			}
			if (do_execute) {
				API.post("/a/profile", {
                    screen_name: this.state.screen_name,
                }, (me) => {
					if (me) Me.set(me);
				});
			}
		};

        const validate_execute_customer_type = (do_execute) => {
            if (!customer_type_changed) {
				return;
			}
			if (do_execute) {
				API.post("/a/profile_type", {customer_type: this.state.customer_type}, (me) => {
					if (me) Me.set(me);
				});
			}
        }

        const validate_execute_gender = (do_execute) => {
            if (!gender_changed) {
				return;
			}
			if (do_execute) {
				API.post("/a/profile_gender", {gender: this.state.gender}, (me) => {
					if (me) Me.set(me);
				});
			}
        }

        const validate_execute_postal_code = (do_execute) => {
            if (!postal_code_changed) {
				return;
			}
			if (do_execute) {
				API.post("/a/profile_postcode", {postal_code: this.state.postal_code}, (me) => {
					if (me) Me.set(me);
				});
			}
        }

		const validate_execute = (do_execute) => {
			validate_execute_email(do_execute);
			validate_execute_screen_name(do_execute);
            validate_execute_customer_type(do_execute);
            validate_execute_gender(do_execute);
            validate_execute_postal_code(do_execute);
		};

		const do_submit = (e) => {
			e.preventDefault();
			validate_execute(true);
		};

		const on_blur = () => {
			validate_execute(false);
		};

		var error_element;
		var has_auth_password_input_error = false;
		var has_email_input_error = false;
		if (this.state.email_err) {
			switch (this.state.email_err) {
			case "auth_error":
				error_element = <span><T>Wrong password</T></span>;
				has_auth_password_input_error = true;
				break;
			case "cannot_disable_login":
				error_element = <span><T>You cannot remove your email (you can remove it after enabling Facebook or Twitter login)</T></span>
				has_email_input_error = true;
				break;
			case "email_conflict":
				error_element = <span><T>The email address is being used by another account</T></span>;
				has_email_input_error = true;
				break;
			case "email_invalid":
				error_element = <span><T>You must enter a valid email address</T></span>;
				has_email_input_error = true;
				break;
			default:
				error_element = <span>{this.state.email_err}</span>
				break;
			}
		}

		var current_password_element;
		if (require_current_password) {
			current_password_element = (
				<Row className="pb-4">
					<Col>
						<div className="mb-2"><T>Current password</T></div>
						<input className={errcls(has_auth_password_input_error, "ad_profile_gray form-control p-3")} type="password" name="auth_password" value={this.state.auth_password} onChange={on_change} onBlur={on_blur}/>
					</Col>
				</Row>
			);
		}

		return (
			<form className="profile_form" onSubmit={do_submit}>
            <Row className="pb-4">
                <Col>
					<TypeSelector type={this.state.customer_type} onChange={on_change} />
				</Col>
            </Row>
            <Row className="pb-4">
                <Col>
					<GenderSelector gender={this.state.gender} onChange={on_change} />
				</Col>
            </Row>
			<Row className="pb-4">
				<Col>
					<div className="mb-2"><T>Name</T></div>
					<input className="ad_profile_gray form-control p-3" type="text" name="screen_name" value={this.state.screen_name} onChange={on_change}/>
				</Col>
			</Row>
			{me.Over18 !== null &&
			<Row className="pb-4">
				<Col>
					<div className="mb-2"><T>Birthdate</T>: {I18N.date(me.Birthdate)}</div>
					<div className="ad_profile_gray font-90">
						<T>To change your birthdate please contact us per email at info@{site_base}.</T>
					</div>
				</Col>
			</Row>}
            <Row className="pb-4">
                <Col>
					<PostcodeSelector postcode={this.state.postal_code} onChange={on_change} />
				</Col>
            </Row>
			<Row className="pb-4">
				<Col>
					<div className="mb-2"><T>Email</T></div>
					<input className={errcls(has_email_input_error, "ad_profile_gray form-control p-3")} type="email" name="email" value={this.state.email} onChange={on_change} onBlur={on_blur}/>
					{unverified_email_notice}
				</Col>
			</Row>
			<div className="pb-3">
				{current_password_element}
			</div>
			{error_element && <div className="errors">{error_element}</div>}
			<Row className="pb-4">
				<Col>
					<Butt disabled={!can_submit} type="submit" className="px-3 py-2"><T>Save changes</T></Butt>
				</Col>
			</Row>

			</form>
		)
	}
}

class OauthStuff extends Component {
	constructor(props) {
		super(props);
		this.state = {
			auth_password: "",
			show_oauth_compulsory_auth_for: "",
			err: "",
		}
	}

	render() {
		const { aua } = this.props;
		const { me, auth } = aua;

		const auaerr = this.props.auaerr || "";

		const compulsory_passwd_auth = auth === "passwd";
		const can_disable_a_login = aua.me.AuthCount > 1;

		const on_change = (e) => {
			this.setState({
				[e.target.name]: e.target.value
			});
		};

		const mk_attach = (platform) => () => {
			if (compulsory_passwd_auth) {
				this.setState({show_oauth_compulsory_auth_for: "attach:" + platform});
			} else {
				aua.request.oauth.attach[platform]();
			}
		}

		const mk_detach = (platform) => () => {
			if (compulsory_passwd_auth) {
				this.setState({show_oauth_compulsory_auth_for: "detach:" + platform});
			} else {
				aua.request.oauth.detach[platform]();
			}
		};

		var fb;
		if (auaerr === "oauth_conflict:fb") {
			fb = (
				<div className="errors">
					<T>You have already connected another
					{site_name} account with Facebook. If
					you want to connect this account, you
					can disconnect from Facebook on the
					other account.</T>
				</div>
			);
		} else if (me.Facebook.IsConnected) {
			if (can_disable_a_login) {
				const fb_name = me.Facebook.Name;
				fb = (
					<Button className="ad_signup_facebook_button" onClick={mk_detach("fb")}>
						<T>Disable Facebook login</T><div className="d-none d-md-inline-block">&nbsp;({fb_name})</div>
					</Button>
				);
			}
		} else {
			fb = (
				<Button className="ad_signup_facebook_button" onClick={mk_attach("fb")}>
					<T>Enable Facebook login</T>
				</Button>
			);
		}

		var twtr;
		if (auaerr === "oauth_conflict:twtr") {
			twtr = (
				<div className="errors">
					<T>You have already connected another
					{site_name} account with Twitter. If
					you want to connect this account, you
					can disconnect from Twitter on the
					other account.</T>
				</div>
			);
		} else if (me.Twitter.IsConnected) {
			if (can_disable_a_login) {
				const twtr_name = me.Twitter.Name;
				twtr = (
					<Button className="ad_signup_twitter_button" onClick={mk_detach("twtr")}>
						<T>Disable Twitter login</T><div className="d-none d-md-inline-block">&nbsp;({twtr_name})</div>
					</Button>
				);
			}
		} else {
			twtr = (
				<Button className="ad_signup_twitter_button" onClick={mk_attach("twtr")}>
					<T>Enable Twitter login</T>
				</Button>
			);
		}

		var error_element;
		var auth_password_input_error = false;
		switch (this.state.err) {
		case "auth_error":
			error_element = <span><T>Wrong password</T></span>
			auth_password_input_error = true;
			break;
		default:
			break;
		}

		if (!this.state.show_oauth_compulsory_auth_for) {
			return (
				<React.Fragment>
					<Row><Col className="pb-3">{fb}</Col></Row>
					<Row><Col>{twtr}</Col></Row>
				</React.Fragment>
			);
		} else {
			const [ action, platform ] = this.state.show_oauth_compulsory_auth_for.split(":");
			const platform_name = {fb: <span>Facebook</span>, twtr: <span>Twitter</span>}[platform];

			const do_cancel = (e) => {
				if (e) e.preventDefault();
				this.setState({show_oauth_compulsory_auth_for: "", auth_password: "", err: ""});
			};

			const execute = (e) => {
				e.preventDefault();
				aua.request.oauth[action][platform](this.state.auth_password, (err) => {
					if (err) {
						this.setState({err: err.code});
					} else {
						do_cancel();
					}
				});
			};

			const enter_password_text = {
				attach: <T>To enable {platform_name} login, please enter your current password:</T>,
				detach: <T>To disable {platform_name} login, please enter your current password:</T>,
			}[action];

			const action_text = {
				attach: <T>Enable {platform_name} login</T>,
				detach: <T>Disable {platform_name} login</T>,
			}[action];

			const can_submit = this.state.auth_password.length > 0;
			return (
				<form onSubmit={execute}>
					<div className="mb-2">
						{enter_password_text}
					</div>
					<div className="pb-3">
						<input className={errcls(auth_password_input_error, "ad_profile_gray form-control p-3")} type="password" name="auth_password" value={this.state.auth_password} onChange={on_change}/>
					</div>
					{error_element && <div className="errors">{error_element}</div>}
					<div className="mt-2 pb-4">
						<Butt disabled={!can_submit} type="submit" className="px-3 py-2 mr-2">{action_text}</Butt>
						<Butt className="px-3 py-2" onClick={do_cancel}>Cancel</Butt>
					</div>
				</form>
			);
		}


	}
}

class DeleteAccount extends Component {
	constructor(props) {
		super(props);
		this.state = {
			auth_password: "",
			show_delete_account: false,
			delete_account_repeat_after_me: "",
			err: "",
		};
	}

	render() {
		const { aua } = this.props;
		const { lang } = aua;

		const on_change = (e) => {
			this.setState({
				[e.target.name]: e.target.value
			});
		};

		if (!this.state.show_delete_account) {
			const show_delete_account = () => { this.setState({show_delete_account: true}); };
			return <Button onClick={show_delete_account} className="ad_btn_danger px-3 py-2"><b><T>DELETE ACCOUNT</T></b></Button>
		} else {
			const delete_account_chkstr = {
				en: "YES DELETE ME",
				da: "JA SLET MIG",
				sv: "JA RADERE MIG",
				de: "JA LOESCHE MICH",
			}[lang];

			const good_parrot = this.state.delete_account_repeat_after_me === delete_account_chkstr;
			const can_submit = good_parrot;

			const do_delete_account = (e) => {
				e.preventDefault();
				aua.request.delete_account(false, (err) => {
					if (err) {
						this.setState({err: err.code});
					} else {
						window.location.href = "/";
					}
				});
			};

			var error_element;
			var parrot_input_error = false;
			switch (this.state.err) {
			default:
				break;
			}

			const do_cancel = (e) => {
				e.preventDefault();
				this.setState({show_delete_account: false, delete_account_repeat_after_me: ""});
			};

			return (
				<form onSubmit={do_delete_account}>
					<Row className="pb-4">
						<Col>
							<div className="mb-2"><T>Type in <span className="ad_yes_delete_me">{delete_account_chkstr}</span> in all caps, exactly as written</T></div>
							<input className={errcls(parrot_input_error, "ad_profile_gray form-control p-3")} type="text" name="delete_account_repeat_after_me" value={this.state.delete_account_repeat_after_me} onChange={on_change}/>
							{error_element && <div className="errors">{error_element}</div>}
						</Col>
					</Row>

					<Row className="pb-4">
						<Col>
							<div className="mt-2">
								<Button disabled={!can_submit} type="submit" className="ad_btn_danger px-3 py-2 mr-2"><b><T>YES, DELETE ACCOUNT</T></b></Button>
								<Butt className="px-3 py-2" onClick={do_cancel}><T>Cancel</T></Butt>
							</div>
						</Col>
					</Row>
				</form>

			)
		}
	}
}

const AccountPane = (props) => {
	const { aua } = props;
	const auaerr = props.auaerr || "";
    
	return (
		<div>
			<div>
				<T>DETAILS</T>
			</div>
			<div className="ad_profile_gray font-90">
				<T>Your personal info is never shared with anyone</T>
				<hr className="ad_profile_gray my-4"/>
			</div>

			<NameEmailBirthdate aua={aua}/>

            <hr />

			<OauthStuff aua={aua} auaerr={auaerr}/>

			<hr className="pb-4"/>

			<Row className="pb-4">
				<Col>
				<div>
					<T>DELETE ACCOUNT</T>
				</div>
				<div className="ad_profile_gray font-90 pb-4">
					<T>Permanently and therefore irrevocably delete your account. There really is no way to undo this.</T>
				</div>
				<DeleteAccount aua={aua}/>
				</Col>
			</Row>
		</div>
	);
}

class PasswordPane extends Component {
	constructor(props) {
		super(props);
		this.state = {
			email: "",
			password: "",
			password_again: "",
			auth_password: "",
			err: "",
		};
	}

	render() {
		const { aua } = this.props;
		const { me, auth } = aua;

		const compulsory_passwd_auth = auth === "passwd";

		const is_enable_login = !me.HasPassword;

		const require_email = !me.HasPassword && me.LocalEmail.length === 0;

		var title;
		if (is_enable_login) {
			title = (
				<React.Fragment>
					<div>
						<T>ENABLE E-MAIL LOGIN</T>
					</div>
					<div className="ad_profile_gray font-90">
						<T>Add the posibility to login with e-mail</T>
						<hr className="ad_profile_gray my-4"/>
					</div>
				</React.Fragment>
			);
		} else {
			title = (
				<React.Fragment>
					<div>
						<T>CHANGE PASSWORD</T>
					</div>
					<div className="ad_profile_gray font-90">
						<T>Change your password here</T>
						<hr className="ad_profile_gray my-4"/>
					</div>
				</React.Fragment>
			);
		}

		const on_change = (e) => {
			this.setState({
				[e.target.name]: e.target.value
			});
		};

		const validate_execute = (do_execute) => {
			const { password, password_again } = this.state;
			const validate_all_the_things = () => {
				if (do_execute && require_email && this.state.email.length === 0) {
					this.setState({err: "email_missing"});
					return false;
				} else if (do_execute && (password.length === 0 || password_again.length === 0)) {
					this.setState({err: "password_missing"});
					return false;
				} else if (password.length > 0 && password_again.length > 0 && password !== password_again) {
					this.setState({err: "password_mismatch"});
					return false;
				} else {
					return true;
				}
			}

			if ((compulsory_passwd_auth && this.state.auth_password.length > 0) || (require_email && this.state.email.length > 0) || do_execute) {
				const dryrun = !do_execute;
				if (dryrun || validate_all_the_things()) {
					aua.request.set_email_password(this.state.auth_password, this.state.email, password, dryrun, (err) => {
						if (err) {
							this.setState({err: err.code});
						} else if (!do_execute) {
							if (validate_all_the_things()) {
								this.setState({err: ""});
							}
						} else if (do_execute) {
							this.setState({
								email: "",
								auth_password: "",
								password: "",
								password_again: "",
							});
						}
					});
				}
			} else {
				if (validate_all_the_things()) {
					this.setState({err: ""});
				}
			}
		};

		const on_submit = (e) => {
			e.preventDefault();
			validate_execute(true);
		};

		const on_blur = () => {
			validate_execute(false);
		};

		var error_element;
		var email_input_error = false;
		var auth_password_input_error = false;
		var password_input_error = false;
		if (this.state.err) {
			switch (this.state.err) {
			case "email_missing":
				error_element = <span><T>You must enter a valid email address</T></span>;
				email_input_error = true;
				break;
			case "email_conflict":
				error_element = <span><T>The email address is being used by another account</T></span>;
				email_input_error = true;
				break;
			case "email_invalid":
				error_element = <span><T>You must enter a valid email address</T></span>;
				email_input_error = true;
				break;
			case "auth_error":
				error_element = <span><T>Wrong password</T></span>;
				auth_password_input_error = true
				break;
			case "password_missing":
				error_element = <span><T>You must enter the password twice</T></span>;
				password_input_error = true;
				break;
			case "password_mismatch":
				error_element = <span><T>The passwords do not match</T></span>;
				password_input_error = true;
				break;
			default:
				error_element = <span>{this.state.err}</span>;
				break;
			}
		}

		/* TODO success_element? i.e. "Yes, we did change your
		 * password". for pure-XHR we can set a state, but with oauth
		 * it's complicated... */

		var email_input;
		if (require_email) {
			email_input = (
				<Row className="pb-4">
					<Col>
						<div className="mb-2"><T>Email</T></div>
						<input className={errcls(email_input_error, "ad_profile_gray form-control p-3")} type="text" name="email" value={this.state.email} onChange={on_change} onBlur={on_blur}/>
					</Col>
				</Row>
			);
		}

		var current_password_input;
		if (compulsory_passwd_auth) {
			current_password_input = (
				<Row className="pb-4">
					<Col>
						<div className="mb-2"><T>Current password</T></div>
						<input className={errcls(auth_password_input_error, "ad_profile_gray form-control p-3")} type="password" name="auth_password" value={this.state.auth_password} onChange={on_change} onBlur={on_blur}/>
					</Col>
				</Row>
			);
		}

		const can_submit =
			(!require_email || this.state.email)
			&& (!compulsory_passwd_auth || this.state.auth_password)
			&& this.state.password
			&& this.state.password_again
			&& this.state.password === this.state.password_again;

		const submit_input = <Butt disabled={!can_submit} className="px-3 py-2">{is_enable_login ? <T>Enable e-mail login</T> : <T>Change password</T>}</Butt>

		return (
			<div>
				{title}
				<form onSubmit={on_submit} className="profile_form">
					{email_input}
					{current_password_input}
					<Row className="pb-4">
						<Col>
							<div className="mb-2">{is_enable_login ? <T>Password</T> : <T>New password</T>}</div>
							<input className={errcls(password_input_error, "ad_profile_gray form-control p-3")} type="password" name="password" value={this.state.password} onChange={on_change} onBlur={on_blur}/>
						</Col>
					</Row>
					<Row className="pb-4">
						<Col>
							<div className="mb-2">{is_enable_login ? <T>Password again</T> : <T>New password again</T>}</div>
							<input className={errcls(password_input_error, "ad_profile_gray form-control p-3")} type="password" name="password_again" value={this.state.password_again} onChange={on_change} onBlur={on_blur}/>
						</Col>
					</Row>

					{error_element && <div className="errors">{error_element}</div>}

					<Row className="pb-4">
						<Col>
							{submit_input}
						</Col>
					</Row>
				</form>
			</div>
		);
	}
}


const mk_email_prefs_component = (get_endpoint, set_endpoint, available_options) => Apify(get_endpoint)
	.with_response_prop("prefs")
	.with_ctl_prop()
.wrap((props) => {

	if (props.prefs === null) return null;

	const mk_checkbox_handler = (key) => (e) => {
		API.post(set_endpoint, {key, value: e.target.checked ? "1" : "0"}, () => {
			props.ctl.reload();
		});
	};

	var options = [];
	for (const opt of available_options) {
		var input_id = "input_id_for_" + opt.key;
		options.push(
			<Row key={opt.key}><Col>
				<input id={input_id} type="checkbox" checked={props.prefs[opt.key]} onChange={mk_checkbox_handler(opt.key)}/>
				<span className="ml-2">
				<label htmlFor={input_id}>{opt.short_text}</label>
				</span>
			</Col></Row>
		);
	}

	return (
		<Container>
			{options}
		</Container>
	);
});


const EmailPrefs = mk_email_prefs_component("/a/email_prefs", "/a/set_email_pref", [
	{
		key: "GameStart",
		short_text: <T>Send an email when a game you have joined starts</T>,
	},
	{
		key: "GameStatus",
		short_text: <T>Send emails about the status of your active games</T>,
	},
]);

const EmailPrefs3p = mk_email_prefs_component(
  "/a/email_prefs_3p",
  "/a/set_email_pref_3p",
  [
    {
      key: "ThirdPartyEmail",
      short_text: <T>Newsletter subscription at mailerlite.com</T>,
    },
  ]
);

const AutoMailPane = (props) => {
	return (
		<div>
			<div className="pb-4">
				<T>Here you can update your email preferences. Please do note that this is not marketing
				emails, but mails about your games and the likes.</T>
			</div>
			<EmailPrefs/>
			<EmailPrefs3p/>
		</div>
	);
}

function PrivacyPane(props) {
	const addr = "info@" + site_base;
	const href = "mailto:" + addr;
	const mailto_link = <a href={href}>{addr}</a>;
	return (
		<div>
			<h2 className="py-3"><T>Privacy</T></h2>
			<T>
			<p>We store the following info about you, if you provided it to us:</p>
			<ul>
				<li>You email address</li>
				<li>Your screen name</li>
				<li>Username and user id for Twitter / Facebook</li>
				<li>Your trade history</li>
				<li>Postal code</li>
				<li>Age</li>
				<li>Gender</li>
				<li>Profession</li>				
			</ul>
			<p>You can see the email address and screen name when
			you edit your profile. Your trade history is available
			under trade history.</p> <p>If you would like to delete
			any of it, send us an email at {mailto_link} and we'll get right to it. Be aware, that if you want to delete your trade
			history, it might affect ongoing games.</p>
			</T>
		</div>
	);
}

const OrderActions = ({ order, onDone }) => {


	const openOrderActionsModal = () => {
        OrderActionsModalInit({
		order,
		onSuccess: () => {
		onDone();
		}
		});
    };

	return (
		<React.Fragment>
			<img 
				src='/gfx/gear-icon-0.svg' 
				alt="gear icon" 
				onClick={openOrderActionsModal} 
				style={{ cursor: 'pointer' }}
			/>
		</React.Fragment>
	);
};

const OrderHistoryPane = (aua) => {
	const { me } = aua.aua;
	const isUserGod = me && me.IsGod === true;
  
	const [orders, setOrders] = useState([]);
	const [total, setTotal]   = useState(0);
	const [page, setPage]     = useState(1);
	const limit = 20; 
	const totalPages = Math.ceil(total / limit);
  
	const fetchOrders = useCallback(() => {
		API.get(`/a/user_orders?page=${page}&limit=${limit}`, resp => {
			if (!resp) {
				setOrders([]);
				setTotal(0);
				return;
			}
			setOrders(Array.isArray(resp.orders) ? resp.orders : []);
			setTotal(typeof resp.total === "number" ? resp.total : 0);
		});
	}, [page, limit]);

	useEffect(() => {
		fetchOrders();
	}, [fetchOrders]);

	const openDetails = o => OrderDetailsModalInit(o);
  
	const statusLabel = o =>
	  o.Status === 'Created' && o.PaymentMethod !== 'ean'
		? <T>Incomplete</T>
		: o.Status;
  
	if (!me) {
	  return <p><T>Please log in to see your orders.</T></p>;
	}
  
	return (
	  <div className="order-history-container">
		<h2 className="py-3"><T>Your orders</T></h2>
  
		{orders.length > 0 ? (
		  <React.Fragment>
			<Table bordered hover responsive className="my-boxed-table">
			  <thead>
				<tr>
				  <th><T>Order ID</T></th>
				  <th><T>Order date</T></th>
				  <th><T>Status</T></th>
				  <th><T>Order total</T></th>
				  <th><T>Actions</T></th>
				</tr>
			  </thead>
			  <tbody>
				{orders.map(o => (
				  <tr key={o.Id}>
					<td>{o.Id}</td>
					<td>{formatDate(new Date(o.CreatedAt))}</td>
					<td>{statusLabel(o)}</td>
					<td>{formatPrice(o.Amount)} {o.Currency}</td>
					<td>
					  <Button size="sm" onClick={() => openDetails(o)}><T>Details</T></Button>{' '}
					  {isUserGod && (
						<React.Fragment>
						<OrderActions order={o} onDone={fetchOrders}/>
						</React.Fragment>
										
					)}
					</td>
				  </tr>
				))}
			  </tbody>
			</Table>
  
			<div className="d-flex justify-content-between align-items-center mt-3">
			  <Button
				onClick={() => setPage(p => Math.max(1, p - 1))}
				disabled={page === 1}
			  >&larr; <T>Prev</T></Button>
  
			  <span><T>Page</T> {page} / {totalPages}</span>
  
			  <Button
				onClick={() => setPage(p => Math.min(totalPages, p + 1))}
				disabled={page === totalPages}
			  ><T>Next</T> &rarr;</Button>
			</div>
		  </React.Fragment>
		) : (
		  <p><T>No orders found.</T></p>
		)}
	  </div>
	);
};


export const OrderHistoryPaneHandler = ({ aua, initialPage = 1, limit = 20 }) => {
	const [page, setPage] = useState(initialPage);
	return (
	  <OrderHistoryPane
		aua={aua}
		page={page}
		limit={limit}
		onPageChange={setPage}
	  />
	);
  };

  const PreferencesInner = memo(function PreferencesInner({ aua, q_err }) {
	const [loginOpened, setLoginOpened] = useState(false);
	if (!aua.me) {
	  if (!loginOpened) {
		OpenLogin();
		setLoginOpened(true);
	  }
	  return null;
	}
  
	const subscription = aua.me.Subscription || 'free';
	const subscriptionStatus =
	  subscription === 'free'
		? <T>Not Premium</T>
		: <T>Premium</T>;
  
	const renderOrderHistory = useCallback(() => (
	  <OrderHistoryPaneHandler aua={aua} />
	), [aua]);
  
	const tabs = useMemo(() => [
	  {
		id: 'account',
		render_title: () => <span><T>Account</T></span>,
		render_pane: () => <AccountPane aua={aua} auaerr={q_err} />
	  },
	  {
		id: 'password',
		render_title: () => <span><T>Password</T></span>,
		render_pane: () => <PasswordPane aua={aua} auaerr={q_err} />
	  },
	  {
		id: 'automail',
		render_title: () => <span><T>Automatic email</T></span>,
		render_pane: () => <AutoMailPane />
	  },
	  {
		id: 'privacy',
		render_title: () => <span><T>Privacy</T></span>,
		render_pane: () => <PrivacyPane />
	  },
	  {
		id: 'order_history',
		render_title: () => <span><T>Your orders</T></span>,
		render_pane: renderOrderHistory
	  },
	], [aua, q_err, renderOrderHistory]);
  
	const tid = R.get_arg("p");
	let tabIndex = tabs.findIndex(t => t.id === tid);
	if (tabIndex < 0) tabIndex = 0;
  
	const onSelectTab = idx => R.go("/preferences?p=:p", { p: tabs[idx].id });
	const TabItems = tabs.map(t => t.render_title());
  
	return (
	  <Container>
		<Row className="py-5">
		  <Col md="3">
			<h2 className="mb-4"><T>Preferences</T></h2>
			<T>
			  <YTab
				selected={tabIndex}
				items={TabItems}
				add_classes={["mb-3"]}
				onSelect={onSelectTab}
			  />
			</T>
		  </Col>
		  <Col md="9">
			<div>
			  <h3>
				<T>Your status:</T>{' '}
				<span className={subscription === 'free' ? 'not-premium-red' : 'premium-green'}>
				  {subscriptionStatus}
				</span>
			  </h3>
			</div>
			<div className="ad_pref_right p-5">
			  {tabs[tabIndex].render_pane()}
			</div>
		  </Col>
		</Row>
	  </Container>
	);
  });

const Preferences = (props) => <AUAContainer><PreferencesInner {...props}/></AUAContainer>;

export default Preferences;



// WEBPACK FOOTER //
// ./src/p/Preferences.js